import { useTranslation } from 'react-i18next';
// Components
import CaliforniaESP from '../Legales/CaliforniaPrivacyUSA/ESP';
import CaliforniaING from '../Legales/CaliforniaPrivacyUSA/ING';
import ProceduresESP from '../Legales/PoliciesAndProcedures/ESP';
import ProceduresING from '../Legales/PoliciesAndProcedures/ING';
import PrivacyESP from '../Legales/PrivacyUSA/ESP';
import PrivacyING from '../Legales/PrivacyUSA/ENG';
import ConsultantESP from '../Legales/AgreementUSA/ESP';
import ConsultantING from '../Legales/AgreementUSA/ING';

export default function LegalModal({ device, type }) {
  const { i18n = {} } = useTranslation();
  const { language = '' } = i18n;
  return (
    (type === 'california' &&
      ((language.includes('es') && <CaliforniaESP device={device} />) || (
        <CaliforniaING device={device} />
      ))) ||
    (type === 'procedures' &&
      ((language.includes('es') && <ProceduresESP device={device} />) || (
        <ProceduresING device={device} />
      ))) ||
    (type === 'privacy' &&
      ((language.includes('es') && <PrivacyESP device={device} />) || (
        <PrivacyING device={device} />
      ))) ||
    (type === 'consultant' &&
      ((language.includes('es') && <ConsultantESP device={device} />) || (
        <ConsultantING device={device} />
      )))
  );
}
